import { z } from 'zod';

/**
 * ActiveProviderSettings — pipeline prompt-generator-only.
 *
 * Hanya satu modality yang relevan: LLM (untuk CONCEPT_GENERATION,
 * STORYBOARD_DRAFT, dan PROMPT_EXPORT). Image, Video, dan TTS dihapus
 * karena tidak ada generasi media di pipeline baru.
 */

// ── LLM ───────────────────────────────────────────────────────────────────────
export const LLM_PROVIDER_OPTIONS = ['cloudflare'] as const;
export type LlmProviderOption = (typeof LLM_PROVIDER_OPTIONS)[number];

// ── Gabungan ──────────────────────────────────────────────────────────────────
export const activeProviderSettingsSchema = z.object({
  /** Provider LLM aktif. Default: 'cloudflare' (Cloudflare AI Workers). */
  llm: z.enum(LLM_PROVIDER_OPTIONS).default('cloudflare'),
});
export type ActiveProviderSettings = z.infer<typeof activeProviderSettingsSchema>;

// ... rest of file remains the same

/** Body PATCH /api/bff/settings/active-providers — semua field opsional. */
export const patchActiveProviderSettingsSchema = activeProviderSettingsSchema.partial();
export type PatchActiveProviderSettings = z.infer<typeof patchActiveProviderSettingsSchema>;

/** Default saat DB belum pernah diisi. */
export const DEFAULT_ACTIVE_PROVIDER_SETTINGS: ActiveProviderSettings = {
  llm: 'cloudflare',
};

// ── Label human-readable untuk UI ────────────────────────────────────────────
export const LLM_PROVIDER_LABELS: Record<LlmProviderOption, string> = {
  cloudflare: 'Cloudflare AI Workers',
};
